import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { IServerSideGetRowsParams } from 'ag-grid-enterprise';
import { forkJoin } from 'rxjs';
import { AuthService } from 'src/app/services/auth.service';
import { CompanyService } from 'src/app/services/company.service';
import { GridService } from 'src/app/services/grid.service';
import { UtilityService } from 'src/app/services/utility.service';

import { BaseGridComponent } from '../base-grid/base-grid.component';

@Component({
  selector: 'app-company-fee-grid',
  templateUrl: '../base-grid/base-grid.component.html',
  styleUrls: [
    './company-fee-grid.component.less',
    '../base-grid/base-grid.component.less'
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class CompanyFeeGridComponent
  extends BaseGridComponent
  implements OnInit
{
  constructor(
    protected override GridService: GridService,
    protected override UtilityService: UtilityService,
    protected override AuthService: AuthService,
    private CompanyService: CompanyService
  ) {
    super(GridService, UtilityService, AuthService);

    this.gridPrimaryKeyFieldName = 'id';
    this.gridType = 'CompanyFee';
    this.rowModelType = 'serverSide';

    this.ServerSideDataSource = {
      getRows: (params: IServerSideGetRowsParams) => {
        const { request } = params;

        const queryObject = this.constructGridQuery({ request });
        const countQueryObject = this.constructGridQuery(
          { request },
          { isCountQuery: true }
        );

        forkJoin([
          this.CompanyService.getCompanyFees(queryObject),
          this.CompanyService.getCompanyFeeCount(countQueryObject)
        ]).subscribe({
          next: ([CompanyFees, CompanyFeesCount]) => {
            const successObject: { rowData: any[]; rowCount: number } = {
              rowData: CompanyFees,
              rowCount: CompanyFeesCount
            };

            params.success(successObject);
          },
          error: (error) => {
            console.log(error);
            params.fail();
          }
        });
      }
    };
  }
}
